import React from "react";

export default function MySQL_LTRIM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_LTRIM</h1>
      <p>This is the MySQL_LTRIM component generated from the SQL JSON.</p>
    </div>
  );
}
